export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION'
export const CLOSE_NOTIFICATION = 'CLOSE_NOTIFICATION'
